import React from 'react';
import { motion } from 'framer-motion';

export default function StatsSection() {
  const stats = [
    { label: "Anos de Tradição", value: "57+" },
    { label: "Clientes Atendidos", value: "1.2k+" },
    { label: "Empresas Abertas", value: "850+" },
    { label: "Retenção de Clientes", value: "98%" }
  ];

  return (
    <section className="w-full bg-orange-600 py-20 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-64 h-64 border-[40px] border-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 border-[60px] border-white rounded-full translate-x-1/3 translate-y-1/3"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 text-center">
          {stats.map((stat, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
            >
              <h3 className="text-5xl md:text-6xl font-black text-white tracking-tighter mb-2">
                {stat.value}
              </h3>
              <p className="text-orange-200 text-[10px] font-bold uppercase tracking-[0.2em]">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
